<template>
  <div id="create-page">
    <b-form @submit.prevent="submitForm">
      <b-tabs>
        <b-tab
          :title="'Information'"
          :title-link-class="['font-medium-5']"
          lazy
        >
          <information
            :formData="formData"
            @onUploadBanner="onUploadBanner"
            @onUploadDisplay="onUploadDisplay"
          />
        </b-tab>
        <b-tab
          :title="'Question and Answer'"
          :title-link-class="['font-medium-5']"
          lazy
        >
          <question-answer
            class="mt-2"
            :formQuestion="formQuestion"
            :optionQuestion="optionQuestion"
            @onFormQuestion="formQuestion"
            @addQuestion="addQuestion"
            @onAddChoice="onAddChoice"
            @onRemoveChoice="onRemoveChoice"
            @onRemoveQuestion="onRemoveQuestion"
            @onUploadImage="onUploadImage"
            @onShowUploadImage="onShowUploadImage"
            @onUploadImageChoice="onUploadImageChoice"
            @onDuplicate="onDuplicate"
          />
        </b-tab>
        <b-tab :title="'Setting'" :title-link-class="['font-medium-5']" lazy>
          <setting :formData="formData" />
        </b-tab>
      </b-tabs>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center flex-wrap mt-3">
          <cancel-button
            :btn-label="'Cancel'"
            class="mr-2"
            stageBack
            @click.native="onBack"
          />
          <save-button
            :type="'submit'"
            :btn-label="'Next'"
            :disabled="validFormDisable"
            :loading="loading.onsave"
          />
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import QuestionAnswer from "./tabs/QuestionAnswer.vue";
import Setting from "./tabs/Setting.vue";
import Information from "./tabs/Information.vue";
import useCreatePage from "../hooks/useCreatePage";

export default {
  components: { QuestionAnswer, Setting, Information },
  props: {
    formDataInfo: { type: Object, default: {} },
    isEdit: { type: Boolean, default: false },
    quizId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      addQuestion,
      formQuestion,
      onAddChoice,
      optionQuestion,
      submitForm,
      formData,
      onUploadBanner,
      onUploadDisplay,
      onUploadImage,
      onShowUploadImage,
      onUploadImageChoice,
      onRemoveChoice,
      onRemoveQuestion,
      onDuplicate,
      onBack,
      nameNoHtml,
      descNoHtml,
      validFormDisable,
      loading
    } = useCreatePage(props);

    return {
      addQuestion,
      formQuestion,
      onAddChoice,
      optionQuestion,
      submitForm,
      formData,
      onUploadBanner,
      onUploadDisplay,
      onUploadImage,
      onShowUploadImage,
      onUploadImageChoice,
      onRemoveChoice,
      onRemoveQuestion,
      onDuplicate,
      onBack,
      nameNoHtml,
      descNoHtml,
      validFormDisable,
      loading
    };
  },
};
</script>

<style>
#create-page .nav-tabs {
  background-color: #fff;
  border-radius: 1.4rem;
  height: 100px;
  padding: 0 40px;
}

#create-page .nav-tabs .nav-link {
  background: #fff !important;
  color: #6d6b7c !important;
  margin-top: 52px;
}

#create-page .nav-tabs .nav-link.active {
  background: transparent !important;
  color: #0050f0 !important;
  border-bottom: 5px solid #0050f0 !important;
}

#create-page .btn-secondary:disabled {
  background-color: #c7cfce !important;
  border-color: #c7cfce !important;
}
</style>

